// Xuất các biểu chứng từ thu mua (UI Biểu 01/02/03 = hàm bieu02/03/04) ra file .xlsx thật (dùng exceljs —
// không dùng skill xlsx của Anthropic, xem CLAUDE.md). Mỗi hàm tự dựng 1
// workbook 1 sheet rồi tải xuống ngay, độc lập với 2 biểu còn lại vì mỗi
// biểu giờ lọc theo khoảng ngày riêng.

import ExcelJS from "exceljs";

const TEN_CONG_TY = "CÔNG TY TNHH LV NÔNG NGHIỆP";
const MAU_HEADER = "FFEFEFEF";

async function taiXuong(workbook, tenFile) {
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = tenFile;
  // Phải gắn vào DOM rồi mới click() để trình duyệt chắc chắn nhận thao tác
  // tải xuống; revoke URL trễ 1 nhịp vì click() kích hoạt tải xuống bất đồng
  // bộ (giống pattern tải zip QR ở quan-ly-sot).
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}

function taoSheet(workbook, { bieuSo, tieuDe, tuNgay, denNgay, soCot }) {
  const sheet = workbook.addWorksheet(`Biểu ${bieuSo}`);
  sheet.mergeCells(1, 1, 1, Math.max(1, soCot - 2));
  sheet.getCell(1, 1).value = TEN_CONG_TY;
  sheet.getCell(1, 1).font = { bold: true };
  sheet.getCell(1, soCot - 1).value = `Biểu ${bieuSo}`;

  sheet.mergeCells(2, 1, 2, soCot);
  sheet.getCell(2, 1).value = tieuDe;
  sheet.getCell(2, 1).font = { bold: true, size: 13 };

  sheet.mergeCells(3, 1, 3, soCot);
  sheet.getCell(3, 1).value = `Từ ngày ${tuNgay} đến ngày ${denNgay}`;
  sheet.getCell(3, 1).font = { italic: true, size: 10 };

  return sheet;
}

function themHeader(sheet, hangSo, cotList) {
  const hang = sheet.getRow(hangSo);
  cotList.forEach((c, i) => {
    const cell = hang.getCell(i + 1);
    cell.value = c.header;
    cell.font = { bold: true };
    cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: MAU_HEADER } };
    cell.alignment = { horizontal: "center", wrapText: true };
    sheet.getColumn(i + 1).width = c.width ?? 16;
    if (c.numFmt) sheet.getColumn(i + 1).numFmt = c.numFmt;
  });
}

export async function xuatExcelBieu02(ketQua, { tuNgay, denNgay }) {
  const workbook = new ExcelJS.Workbook();
  const cotList = [
    { header: "STT", width: 6 },
    // numFmt tường minh + ghi Date thật (không phải chuỗi "dd/mm/yyyy" tự
    // build) — nếu ghi chuỗi, Excel tự nhận diện "trông giống ngày" rồi diễn
    // giải lại theo locale hệ điều hành máy MỞ file (thường mặc định en-US
    // mm/dd/yyyy), đảo ngược ngày/tháng dù chuỗi gốc đúng dd/mm/yyyy. Ghi Date
    // + numFmt thì Excel tự hiển thị đúng theo numFmt này, không phụ thuộc
    // locale máy mở file.
    { header: "Ngày", width: 12, numFmt: "dd/mm/yyyy" },
    { header: "Tên hộ nông dân", width: 20 },
    { header: "CCCD", width: 18, numFmt: "@" },
    { header: "Địa chỉ", width: 30 },
    { header: "Loại bơ", width: 14 },
    { header: "Số lượng (kg)", width: 14, numFmt: "#,##0.00" },
    { header: "Đơn giá (đ/kg)", width: 14, numFmt: "#,##0" },
    { header: "Thành tiền (đ)", width: 16, numFmt: "#,##0" },
    { header: "Ghi chú chứng từ đầu vào", width: 26 },
  ];
  const sheet = taoSheet(workbook, {
    bieuSo: "01",
    tieuDe: "Bảng kê chi tiết thu mua từ các hộ nông dân",
    tuNgay,
    denNgay,
    soCot: cotList.length,
  });
  themHeader(sheet, 5, cotList);

  ketQua.dong.forEach((d) => {
    const hang = sheet.addRow([
      d.stt,
      new Date(d.thoiGian),
      d.tenChuVuon,
      String(d.cccd ?? "—"),
      d.diaChi,
      d.tenLoaiBo,
      d.soLuong,
      d.donGia,
      d.thanhTien,
      d.ghiChu,
    ]);
    hang.getCell(4).numFmt = "@";
  });
  const hangTong = sheet.addRow([
    "",
    "",
    "TỔNG CỘNG",
    "",
    "",
    "",
    ketQua.tong.soLuong,
    "—",
    ketQua.tong.thanhTien,
    "",
  ]);
  hangTong.font = { bold: true };

  await taiXuong(workbook, `chung-tu-thu-mua-bieu-01_${tuNgay}_${denNgay}.xlsx`);
}

export async function xuatExcelBieu03(ketQua, { tuNgay, denNgay }) {
  const workbook = new ExcelJS.Workbook();
  const cotList = [
    { header: "Người thu mua", width: 18 },
    // Xem giải thích numFmt + ghi Date thật ở xuatExcelBieu02 — tránh Excel tự
    // diễn giải sai dd/mm thành mm/dd theo locale máy mở file.
    { header: "Ngày giờ", width: 18, numFmt: "dd/mm/yyyy hh:mm:ss" },
    { header: "Chủ vườn", width: 20 },
    { header: "Mã Sọt", width: 14 },
    { header: "SL mua (kg)", width: 13, numFmt: "#,##0.00" },
    { header: "Đơn giá (đ/kg)", width: 14, numFmt: "#,##0" },
    { header: "Thành tiền (đ)", width: 16, numFmt: "#,##0" },
    { header: "SL nhập kho (kg)", width: 15, numFmt: "#,##0.00" },
    { header: "SL hao hụt (kg)", width: 18 },
    { header: "Tỷ lệ hao hụt", width: 13, numFmt: "0.0%" },
  ];
  const sheet = taoSheet(workbook, {
    bieuSo: "02",
    tieuDe: "Bảng tổng hợp theo nhân viên thu mua",
    tuNgay,
    denNgay,
    soCot: cotList.length,
  });
  themHeader(sheet, 5, cotList);

  ketQua.dong.forEach((d) => {
    sheet.addRow([
      d.tenNhanVien,
      new Date(d.thoiGian),
      d.tenChuVuon,
      d.maSotHienThi,
      d.slMua,
      d.donGiaMua,
      d.tienMua,
      d.slNhapKho ?? "—",
      d.chuaNhapKho ? "0 (Chưa nhập kho)" : d.haoHut,
      d.tyLeHaoHut != null ? d.tyLeHaoHut : "—",
    ]);
  });
  const hangTong = sheet.addRow([
    "TỔNG CỘNG",
    "",
    "",
    "",
    ketQua.tong.slMua,
    "—",
    ketQua.tong.tienMua,
    ketQua.tong.slNhapKho,
    ketQua.tong.haoHut,
    ketQua.tong.tyLeHaoHut,
  ]);
  hangTong.font = { bold: true };

  await taiXuong(workbook, `chung-tu-thu-mua-bieu-02_${tuNgay}_${denNgay}.xlsx`);
}

export async function xuatExcelBieu04(ketQua, { tuNgay, denNgay }) {
  const workbook = new ExcelJS.Workbook();
  const cotList = [
    { header: "Hợp tác xã (điểm thu mua)", width: 26 },
    { header: "Người thu mua", width: 18 },
    { header: "Loại bơ", width: 16 },
    { header: "SL mua (kg)", width: 14, numFmt: "#,##0.00" },
    { header: "Đơn giá mua (đ/kg)", width: 16, numFmt: "#,##0" },
    { header: "Thành tiền mua (đ)", width: 18, numFmt: "#,##0" },
  ];
  const sheet = taoSheet(workbook, {
    bieuSo: "03",
    tieuDe: "Bảng tổng hợp thu mua theo hợp tác xã (điểm thu mua)",
    tuNgay,
    denNgay,
    soCot: cotList.length,
  });
  themHeader(sheet, 5, cotList);

  ketQua.nhom.forEach((n) => {
    const hangNhom = sheet.addRow([n.tenHopTacXa, "", "", "", "", ""]);
    hangNhom.font = { bold: true };
    hangNhom.fill = { type: "pattern", pattern: "solid", fgColor: { argb: MAU_HEADER } };

    n.dong.forEach((d) => {
      sheet.addRow(["", d.tenNhanVien, d.tenLoaiBo, d.slMua, d.donGiaMua, d.tienMua]);
    });

    const hangCong = sheet.addRow([
      "",
      "",
      `Cộng ${n.tenHopTacXa}`,
      n.tong.slMua,
      "—",
      n.tong.tienMua,
    ]);
    hangCong.font = { italic: true };
  });

  const hangTong = sheet.addRow([
    "TỔNG CỘNG",
    "",
    "",
    ketQua.tongChung.slMua,
    "—",
    ketQua.tongChung.tienMua,
  ]);
  hangTong.font = { bold: true };

  await taiXuong(workbook, `chung-tu-thu-mua-bieu-03_${tuNgay}_${denNgay}.xlsx`);
}
